import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { BlogCategoryService } from '../../services/blog/blog-category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Blog } from '../../models/blog/blog-model';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-edit-blog-category',
    templateUrl: './edit-blog-category.component.html',
    styleUrls: ['./edit-blog-category.component.css']
})
/** edit-blog-category component*/
export class EditBlogCategoryComponent {
    /** edit-blog-category ctor */
  blogCategory = new BlogCategory();
  validate: boolean;
  constructor(private _avRoute: ActivatedRoute,
    private readonly blogCategoryService: BlogCategoryService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("blogcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.getBlogCategoryById(this._avRoute.snapshot.params["id"]);
              this.toastr.setRootViewContainerRef(vcr);
            }
            this.validate = true;

          }
          else {
            this.router.navigate(["/blogcategory-list"]);
          }
        }
        else {
          this.router.navigate(["/blogcategory-list"]);
        }
      }
    )

    
  }
  getBlogCategoryById(id: string) {
    this.blogCategoryService.getBlogCategoryById(id).subscribe(
      data => {
        this.blogCategory = data;
      }
    )
  }
  isActiveCheckbox(e) {
    this.blogCategory.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.blogCategoryService.updateBlogCategory(this.blogCategory).subscribe(result => {
      if (result) {
        this.toastr.success('Blog Category has been Updated.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/blogcategory-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/blog-components/edit-blog-category/edit-blog-category.component.ts